import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { TopUpOperator } from './TopUpOperator'
import './styles.css'

const operatorMode = new URLSearchParams(window.location.search).get('operator') === 'jobs-top-up'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {operatorMode ? <TopUpOperator /> : <App />}
  </StrictMode>,
)
